import { Box, Text, Flex } from '@chakra-ui/react';
import { HiOutlinePlusSmall } from 'react-icons/hi2';
import { MdAlternateEmail } from 'react-icons/md';
import ContactItem from './ContactItem';

import { useSelector } from 'react-redux';

const emailList = [
  { id: 1, email: 'abc@gmail.com', emailStatus: true },
  { id: 2, email: 'abd@gmail.com', emailStatus: false },
];

const EmailInfo = () => {
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);

  if (activeProspect?.emailInfo)
    return (
      <Box>
        <Flex justifyContent="space-between" px={3} pb={3}>
          <Text fontSize={12} fontWeight={600} color="orange.primary">
            EMAIL
          </Text>
          <Text color="orange.primary" fontSize={18}>
            <HiOutlinePlusSmall />
          </Text>
        </Flex>
        {activeProspect?.emailInfo.length > 0 &&
          activeProspect?.emailInfo?.map((item, index) => (
            <ContactItem
              key={index}
              icon={<MdAlternateEmail />}
              email={item.email_address || 'No Email'}
              emailStatus={item.emailStatus}
              type="email"
            />
          ))}
      </Box>
    );
};
export default EmailInfo;
